import config from 'config'

export default {
    getCorpTags: {
        url: `${config.apiHost}/oem-customer/api/corp_tags`,
        type: 'GET',
    },
}
